var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 90,
    viewBox: "0 0 343 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M301.911 55.9495C300.171 55.9495 298.729 57.3055 298.51 59.0518H256.928L245.652 45.9187H105.376L88.6217 68.7521H57.5808C57.1563 67.285 55.843 66.211 54.2932 66.211C52.4016 66.211 50.8604 67.812 50.8604 69.7777C50.8604 71.7434 52.4016 73.3445 54.2932 73.3445C56.1506 73.3445 57.6634 71.8061 57.7203 69.8917H89.2171L105.971 47.0582H245.162L256.435 60.1914H298.541C298.846 61.8352 300.239 63.0801 301.911 63.0801C303.803 63.0801 305.344 61.4791 305.344 59.5134C305.344 57.5477 303.803 55.9495 301.911 55.9495ZM54.2932 72.4898C52.8545 72.4898 51.6837 71.2734 51.6837 69.7777C51.6837 68.2821 52.8545 67.0656 54.2932 67.0656C55.7319 67.0656 56.9027 68.2821 56.9027 69.7777C56.9027 71.2734 55.7319 72.4898 54.2932 72.4898ZM301.911 62.2283C300.473 62.2283 299.302 61.0119 299.302 59.5162C299.302 58.0206 300.473 56.8041 301.911 56.8041C303.35 56.8041 304.521 58.0206 304.521 59.5162C304.521 61.0119 303.35 62.2283 301.911 62.2283Z",
    fill: "#5F98F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M327.924 32.0505C326.098 32.0505 324.602 33.5433 324.5 35.415H295.102L277.659 16.5728H250.549L241.197 26.6776H102.313L90.4732 42.8504L80.867 32.3183H15.1528C14.6628 30.9708 13.4122 30.0079 11.9451 30.0079C10.0534 30.0079 8.51221 31.6089 8.51221 33.5746C8.51221 35.5403 10.0534 37.1414 11.9451 37.1414C13.8367 37.1414 15.3779 35.5403 15.3779 33.5746C15.3779 33.5347 15.3722 33.4977 15.3722 33.4578H80.3941L90.5644 44.6082L102.854 27.82H241.661L251.014 17.7151H277.192L294.635 36.5573H324.616C325.015 38.0701 326.346 39.1868 327.924 39.1868C329.815 39.1868 331.357 37.5858 331.357 35.6201C331.357 33.6544 329.815 32.0505 327.924 32.0505ZM11.9422 36.2839C10.5035 36.2839 9.33267 35.0674 9.33267 33.5718C9.33267 32.0761 10.5035 30.8597 11.9422 30.8597C13.3809 30.8597 14.5517 32.0761 14.5517 33.5718C14.5517 35.0674 13.3837 36.2839 11.9422 36.2839ZM327.924 38.3293C326.485 38.3293 325.314 37.1129 325.314 35.6172C325.314 34.1216 326.485 32.9051 327.924 32.9051C329.362 32.9051 330.533 34.1216 330.533 35.6172C330.533 37.1129 329.362 38.3293 327.924 38.3293Z",
    fill: "#5F98F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M163.5 90C202.436 90 234 69.8528 234 45C234 20.1472 202.436 0 163.5 0C124.564 0 93 20.1472 93 45C93 69.8528 124.564 90 163.5 90Z",
    fill: "url(#paint0_radial_17_768)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M99.903 12.3822C101.461 12.3822 102.723 11.1194 102.723 9.56181C102.723 8.00417 101.461 6.74146 99.903 6.74146C98.3453 6.74146 97.0826 8.00417 97.0826 9.56181C97.0826 11.1194 98.3453 12.3822 99.903 12.3822Z",
    fill: "#5F98F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M224.639 77.9339C226.197 77.9339 227.46 76.6712 227.46 75.1136C227.46 73.5559 226.197 72.2932 224.639 72.2932C223.082 72.2932 221.819 73.5559 221.819 75.1136C221.819 76.6712 223.082 77.9339 224.639 77.9339Z",
    fill: "#5F98F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M221.816 64.7922C222.803 64.7922 223.602 63.9925 223.602 63.006C223.602 62.0195 222.803 61.2197 221.816 61.2197C220.83 61.2197 220.03 62.0195 220.03 63.006C220.03 63.9925 220.83 64.7922 221.816 64.7922Z",
    fill: "#5F98F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M48.2764 53.3796C50.1581 53.3796 51.6836 51.8541 51.6836 49.9724C51.6836 48.0906 50.1581 46.5652 48.2764 46.5652C46.3946 46.5652 44.8691 48.0906 44.8691 49.9724C44.8691 51.8541 46.3946 53.3796 48.2764 53.3796Z",
    fill: "#5F98F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M300.94 26.3784C302.546 26.3784 303.848 25.0761 303.848 23.4697C303.848 21.8633 302.546 20.561 300.94 20.561C299.333 20.561 298.031 21.8633 298.031 23.4697C298.031 25.0761 299.333 26.3784 300.94 26.3784Z",
    fill: "#5F98F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M270.283 48.0865C271.086 48.0865 271.736 47.436 271.736 46.6336C271.736 45.8312 271.086 45.1807 270.283 45.1807C269.481 45.1807 268.831 45.8312 268.831 46.6336C268.831 47.436 269.481 48.0865 270.283 48.0865Z",
    fill: "#5F98F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M109.025 18.3959C109.667 18.3959 110.187 17.8755 110.187 17.2336C110.187 16.5917 109.667 16.0713 109.025 16.0713C108.383 16.0713 107.863 16.5917 107.863 17.2336C107.863 17.8755 108.383 18.3959 109.025 18.3959Z",
    fill: "#5F98F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145.912 21.0625L130.28 65.4559L188.391 75.1078C188.391 75.1078 191.883 75.4582 192.712 71.2476L202.367 28.7401C202.367 28.7401 203.057 24.3529 199.242 24.0025L145.912 21.0625Z",
    fill: "#080123"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M135.166 64.8378L130.28 65.456C130.28 65.456 123.46 64.1598 127.001 60.5361L189.584 41.7964L175.659 34.2356L177.297 58.2057L173.027 64.8606L135.166 64.8378Z",
    fill: "#080123"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M142.077 16.1768L126.221 61.6272L186.36 70.6779C186.36 70.6779 190.322 71.2107 191.174 66.8633L201.441 23.165C201.441 23.165 201.926 17.3648 197.988 17.003L143.926 14.9832C143.097 14.9376 142.339 15.4276 142.077 16.1768Z",
    fill: "#14125E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.077 15.1826L126.221 61.6272L186.36 69.6808C186.36 69.6808 189.966 70.0426 190.818 65.6982L200.78 21.8318C200.78 21.8318 201.493 17.305 197.555 16.9432L143.923 13.9861C143.097 13.9405 142.339 14.4305 142.077 15.1826Z",
    fill: "url(#paint1_linear_17_768)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.474 36.5089L174.97 44.9159C174.827 45.3945 174.77 45.8902 174.808 46.383C174.919 47.8644 175.628 50.6221 179.052 50.7702L194.197 53.243C194.855 53.3512 195.388 53.8156 195.556 54.4338L196.088 56.3824L200.832 39.8022L199.433 35.6343L181.784 33.3724C181.781 33.3724 178.753 33.0476 177.474 36.5089Z",
    fill: "#7A2374"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M177.423 36.6769L175.312 44.2064C175.169 44.685 175.112 45.1807 175.149 45.6735C175.26 47.1549 175.97 49.9126 179.705 50.112L194.903 52.5933C195.536 52.6959 196.057 53.1232 196.265 53.7016L197.279 56.5561L201.655 39.8391L200.31 36.3293C199.98 35.4661 199.176 34.8508 198.222 34.7283L182.798 33.3153C180.596 33.113 178.485 34.2725 177.614 36.2125C177.548 36.3578 177.485 36.5117 177.423 36.6769Z",
    fill: "url(#paint2_linear_17_768)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M177.423 36.6769L175.312 44.2064C175.169 44.685 175.112 45.1807 175.149 45.6735C175.26 47.1549 175.97 49.9126 179.705 50.112L194.903 52.5933C195.536 52.6959 196.057 53.1232 196.265 53.7016L197.279 56.5561L201.655 39.8391L200.31 36.3293C199.98 35.4661 199.176 34.8508 198.222 34.7283L182.798 33.3153C180.596 33.113 178.485 34.2725 177.614 36.2125C177.548 36.3578 177.485 36.5117 177.423 36.6769Z",
    fill: "url(#paint3_linear_17_768)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M196.248 54.7415L196.085 56.3852L197.282 56.5533L196.635 54.7415H196.248Z",
    fill: "#7A2374"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M186.679 45.0305C188.725 43.3281 189.191 40.5134 187.719 38.7438C186.247 36.9741 183.395 36.9196 181.348 38.6221C179.301 40.3245 178.835 43.1392 180.307 44.9088C181.779 46.6785 184.632 46.733 186.679 45.0305Z",
    fill: "#B18BB7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M186.138 44.5365C188.089 42.9136 188.533 40.23 187.129 38.5426C185.726 36.8552 183.006 36.8029 181.055 38.4259C179.104 40.0488 178.66 42.7324 180.064 44.4198C181.468 46.1072 184.187 46.1595 186.138 44.5365Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17_768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.493 44.9975) scale(70.4967 44.9968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F98F2",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16162D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17_768",
    x1: 67.8258,
    y1: 70.6246,
    x2: 282.287,
    y2: 7.31309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0858,
    stopColor: "#260B45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5983,
    stopColor: "#3A2F85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17_768",
    x1: 157.607,
    y1: 54.3079,
    x2: 227.674,
    y2: 33.6232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0858,
    stopColor: "#8D29C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2383,
    stopColor: "#942BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#A92FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7413,
    stopColor: "#CA3793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03F77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17_768",
    x1: 184.065,
    y1: 43.5876,
    x2: 203.401,
    y2: 46.4856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5109,
    stopColor: "#A92FAC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5461,
    stopColor: "#882B89",
    stopOpacity: 0.0414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5931,
    stopColor: "#612662",
    stopOpacity: 0.0965
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6395,
    stopColor: "#442243",
    stopOpacity: 0.151
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6845,
    stopColor: "#2E1F2D",
    stopOpacity: 0.2038
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7275,
    stopColor: "#211E20",
    stopOpacity: 0.2543
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7664,
    stopColor: "#1D1D1B",
    stopOpacity: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.e3e7cdae0dd3255fe7e7b9c71ace8ba7.svg";
export { ForwardRef as ReactComponent };